import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {EnvironmentModel} from '@common/generic';


@Injectable({
  providedIn: 'root'
})
export class AppConfig {
  static settings: EnvironmentModel;
  internalhttp: HttpClient;

  constructor(httpBackend: HttpBackend) {
    // use a different HttpClient which won't be intercepted by InterceptorService
    this.internalhttp = new HttpClient(httpBackend);
  }

  load(){
    const jsonFile = `assets/config.json`;
    return this.internalhttp.get<EnvironmentModel>(jsonFile).toPromise().then((response) => {
      AppConfig.settings = response;
    })
  }
}
